import { createSlice } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../libs/utils/constants/async-status';
import { checkReferentialWhitelistThunk } from './referential-access-thunk';
import { IReferentialAccess } from './referential-access-interface';

export const initialState: IReferentialAccess = {
    asyncStatus: AsyncStatus.INITIAL,
    ecrId: '',
    isWhitelisted: false,
    clientDetails: {
        id: 0,
        name: '',
        ecrId: '',
        elsevierClient: false,
        contractStartDate: '',
        contractEndDate: '',
        hasSkillAuthorization: false,
        eolsCourseId: null,
    },
    referentialAccessDetails: [],
    asyncStatusReferential: AsyncStatus.INITIAL,
    asyncStatusWhitelisted: AsyncStatus.INITIAL,
};

const referentialAccessSlice = createSlice({
    name: 'referentialAccess',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                checkReferentialWhitelistThunk.pending,
                (state: IReferentialAccess) => {
                    state.asyncStatus = AsyncStatus.LOADING;
                    state.asyncStatusReferential = AsyncStatus.LOADING;
                    state.asyncStatusWhitelisted = AsyncStatus.LOADING;
                }
            )
            .addCase(
                checkReferentialWhitelistThunk.fulfilled,
                (state: IReferentialAccess, { payload }: any) => {
                    state.asyncStatus = AsyncStatus.SUCCESS;
                    state.asyncStatusReferential = AsyncStatus.SUCCESS;
                    state.asyncStatusWhitelisted = AsyncStatus.SUCCESS;
                    state.isWhitelisted = payload.whitelisted;
                    if (payload.clientDetails) {
                        state.clientDetails = payload.clientDetails;
                    }
                }
            )
            .addCase(
                checkReferentialWhitelistThunk.rejected,
                (state: IReferentialAccess) => {
                    state.asyncStatus = AsyncStatus.FAILURE;
                    state.asyncStatusReferential = AsyncStatus.FAILURE;
                    state.asyncStatusWhitelisted = AsyncStatus.FAILURE;
                    state.isWhitelisted = false;
                }
            );
    },
});

export default referentialAccessSlice.reducer;
